import TextInput from './TextInput'

class IntegerInput extends TextInput {
  onChange(event, data) {
    let value = String(data.value)
    if (value !== '') {
      value = Number(value)
      if (!Number.isInteger(value)) {
        return
      }
      if (
        this.props.max
        &&
        Number.isInteger(this.props.max)
        &&
        value > this.props.max
      ) {
        return
      }
    }
    this.setState({
      value
    })
  }
}

export default IntegerInput



// WEBPACK FOOTER //
// ./src/components/elements/forms/IntegerInput.js